import { createApp, defineAsyncComponent } from "vue";

import SvgVue from 'svg-vue3'
import VueLazyLoad from 'vue3-lazyload'
import VueSocialSharing from 'vue-social-sharing'

const app = createApp({
  components: {

    Slider: defineAsyncComponent(() => import('./common/Slider.vue')),
    SocialIcons: defineAsyncComponent(() => import('./common/SocialMediaIcons.vue')),
    ContactForm: defineAsyncComponent(() => import('./common/ContactForm.vue')),
    EmploymentForm: defineAsyncComponent(() => import('./common/EmploymentForm.vue')),
    VideoFeed: defineAsyncComponent(() => import('./common/VideoFeed.vue')),
    ProjectGallery: defineAsyncComponent(() => import('./common/ProjectGallery.vue')),

    PhotoGallery: defineAsyncComponent(() => import('./blocks/PhotoGallery.vue')),
    AccordionList: defineAsyncComponent(() => import('./blocks/AccordionList.vue')),
    AccordionPanels: defineAsyncComponent(() => import('./blocks/AccordionPanels.vue')),
    TabBox: defineAsyncComponent(() => import('./blocks/TabBox.vue')),

  },

  data: () => ({
    openMenu: '',
    scrollPosition: 0,
    activeSideBarNav: '',
    alertsOpen: false,
    activeFaq: '',
    activeMobileNavGroup: 0,
  }),

  computed: {
    mobileMenu () {
      return this.openMenu === 'mobileMenu'
    },
    isScrolling () {
      return this.scrollPosition > 0
    },
  },

  methods: {
    toggleMenu (menu) {
      this.openMenu = (this.openMenu != menu ? menu : '')
    },
    setMobileNavGroup (item) {
      this.activeMobileNavGroup = this.activeMobileNavGroup != item ? item : ''
    },
    handleScroll (event) {
      this.scrollPosition = window.pageYOffset != undefined ? window.pageYOffset : window.scrollY
    },
    setSidebar (sidebar) {
      this.activeSideBarNav = sidebar
    },
  },

  created() {
    window.addEventListener("scroll", this.handleScroll);
  },

  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },

})

app.use(VueLazyLoad)
app.use(SvgVue, {
  svgPath: 'resources/svg',
  extract: false,
  svgoSettings: [
      { removeTitle: true },
      { removeViewBox: false },
      { removeDimensions: true }
  ]
})
app.use(VueSocialSharing);


app.mount("#app")
